import { IApplicationState } from '../../types/redux';
import { ENewReviewStep } from '../../types/newReview';

export const selectIsCurrentStepValid = (state: IApplicationState): boolean => {
  if (state.newReview.meta.step === ENewReviewStep.Rating) {
    const { overallScore } = state.newReview.data;

    return Boolean(overallScore);
  }

  return true;
};
